/**
 * MainNav functionality.
 * @author Dayne Coulson-Hoffacker
 */
export default class MainNav {
  /**
   * Constructs a new MainNav instance.
   * @param {Object} options - Options.
   * @param {HTMLElement} options.element - Container.
   */
  constructor (options) {
    this.element = options.element
    this.navItems = this.element.queryAll('#menu-main-navigation > li.menu-item-has-children')

    this.navItems.forEach(element => {
      var subMenu = element.querySelector('.sub-menu-wrapper')
      element.addEventListener('mouseenter', (e) => {
        element.classList.add('show-sub-menu')
      })
      element.addEventListener('mouseleave', (e) => {
        this.hideClasses(this.navItems)
      })
    })
  }

  /**
  * Closes expanded state.
  */
  hideClasses (navItems) {
    this.navItems.forEach(element => {
      element.classList.remove('show-sub-menu')
      element.classList.remove('current-menu-parent')
    })
  }
}



// WEBPACK FOOTER //
// ./components/global-header/main-nav/index.js